import { supabase } from "@/supabase";

export async function carregarTurmas() {

    const { data, error } = await supabase
        .from('turmas')
        .select('*')
        .order('ano', { ascending: true })

        if(error) {
            console.log(error.message) 
            return []
        }

        return data
    
}

export async function carregarDisciplinas() {
    const { data, error } = await supabase
        .from("disciplinas")
        .select("*")

    if (error) {
        console.log(error.message);
        return false;
    }

    return data;
}

export async function carregarEstudantes(idDaTurma) {

    const { data, error } = await supabase
        .from('estudantes_turmas')
        .select('users(id, nome, img)')
        .eq('idDaTurma', idDaTurma)
        .order('users(nome)')

    if (error) {
        console.log(error.message)
        return []
    }


    const dadosFormatados = data.map((estudante) => {
        return {
            id: estudante.users.id,
            nome: estudante.users.nome,
            img: estudante.users.img
        }
    })

    return dadosFormatados
}



export async function carregarNotasDosAlunos(idsAlunos) {
    let dataAtual = new Date();
    let anoAtual = dataAtual.getFullYear();
    let inicioAno = new Date(anoAtual, 0, 1); // 1º de Janeiro do ano atual
    let inicioAnoFormatado = inicioAno.toISOString();

    const { data, error } = await supabase
        .from('planos_notas')
        .select('nota, created_at, avaliacao, estudante')
        .in('estudante', idsAlunos)
        .gte('created_at', inicioAnoFormatado); 

    if (error) {
        console.error('Erro ao buscar dados:', error.message);
        return [];
    }
    return data;
}

export async function carregarAvaliacoesInfo(idsAvaliacoes){

    const { data, error } = await supabase
        .from('planos_avaliacoes')
        .select('*, planos(titulo, planos_aulas(aulas(cursos(disciplina)))))')
        .in('id', idsAvaliacoes)

    if (error) {
        console.error('Erro ao buscar dados:', error.message);
        return [];
    }
    console.log(data)

    const dadosFormatados = data.map((avaliacao) => {
        return {
            id: avaliacao.id,
            tipo: avaliacao.tipo,
            tituloAvaliacao: avaliacao.titulo,
            tituloPlano: avaliacao.planos.titulo,
            disciplina: avaliacao.planos.planos_aulas[0].aulas.cursos.disciplina,
            nivel1: avaliacao.nivel1,
            nivel2: avaliacao.nivel2,
            nivel3: avaliacao.nivel3,
            nivel4: avaliacao.nivel4,
            criterio: avaliacao.criterio
        }
    })

    return dadosFormatados
}
